angular.module('shared').filter('emptyDash', [() => {
  return function(data) {
    if (!data) {
      return '-';
    } else {
      return data;
    }
  };
}]);